(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
module.exports = require('./lib/fuzzyset.js');

},{"./lib/fuzzyset.js":2}],2:[function(require,module,exports){
(function() {

var FuzzySet = function(arr, useLevenshtein, gramSizeLower, gramSizeUpper) {
    var fuzzyset = {

    };

    // default options
    arr = arr || [];
    fuzzyset.gramSizeLower = gramSizeLower || 2;
    fuzzyset.gramSizeUpper = gramSizeUpper || 3;
    fuzzyset.useLevenshtein = (typeof useLevenshtein !== 'boolean') ? true : useLevenshtein;

    // define all the object functions and attributes
    fuzzyset.exactSet = {};
    fuzzyset.matchDict = {};
    fuzzyset.items = {};

    // helper functions
    var levenshtein = function(str1, str2) {
        var current = [], prev, value;

        for (var i = 0; i <= str2.length; i++)
            for (var j = 0; j <= str1.length; j++) {
            if (i && j)
                if (str1.charAt(j - 1) === str2.charAt(i - 1))
                value = prev;
                else
                value = Math.min(current[j], current[j - 1], prev) + 1;
            else
                value = i + j;

            prev = current[j];
            current[j] = value;
            }

        return current.pop();
    };

    // return an edit distance from 0 to 1
    var _distance = function(str1, str2) {
        if (str1 === null && str2 === null) throw 'Trying to compare two null values';
        if (str1 === null || str2 === null) return 0;
        str1 = String(str1); str2 = String(str2);

        var distance = levenshtein(str1, str2);
        if (str1.length > str2.length) {
            return 1 - distance / str1.length;
        } else {
            return 1 - distance / str2.length;
        }
    };
    var _nonWordRe = /[^a-zA-Z0-9\u00C0-\u00FF, ]+/g;

    var _iterateGrams = function(value, gramSize) {
        gramSize = gramSize || 2;
        var simplified = '-' + value.toLowerCase().replace(_nonWordRe, '') + '-',
            lenDiff = gramSize - simplified.length,
            results = [];
        if (lenDiff > 0) {
            for (var i = 0; i < lenDiff; ++i) {
                simplified += '-';
            }
        }
        for (var i = 0; i < simplified.length - gramSize + 1; ++i) {
            results.push(simplified.slice(i, i + gramSize));
        }
        return results;
    };

    var _gramCounter = function(value, gramSize) {
        // return an object where key=gram, value=number of occurrences
        gramSize = gramSize || 2;
        var result = {},
            grams = _iterateGrams(value, gramSize),
            i = 0;
        for (i; i < grams.length; ++i) {
            if (grams[i] in result) {
                result[grams[i]] += 1;
            } else {
                result[grams[i]] = 1;
            }
        }
        return result;
    };

    // the main functions
    fuzzyset.get = function(value, defaultValue, minMatchScore) {
        // check for value in set, returning defaultValue or null if none found
        if (minMatchScore === undefined) {
            minMatchScore = .33
        }
        var result = this._get(value, minMatchScore);
        if (!result && typeof defaultValue !== 'undefined') {
            return defaultValue;
        }
        return result;
    };

    fuzzyset._get = function(value, minMatchScore) {
        var normalizedValue = this._normalizeStr(value),
            result = this.exactSet[normalizedValue];
        if (result) {
            return [[1, result]];
        }

        var results = [];
        // start with high gram size and if there are no results, go to lower gram sizes
        for (var gramSize = this.gramSizeUpper; gramSize >= this.gramSizeLower; --gramSize) {
            results = this.__get(value, gramSize, minMatchScore);
            if (results && results.length > 0) {
                return results;
            }
        }
        return null;
    };

    fuzzyset.__get = function(value, gramSize, minMatchScore) {
        var normalizedValue = this._normalizeStr(value),
            matches = {},
            gramCounts = _gramCounter(normalizedValue, gramSize),
            items = this.items[gramSize],
            sumOfSquareGramCounts = 0,
            gram,
            gramCount,
            i,
            index,
            otherGramCount;

        for (gram in gramCounts) {
            gramCount = gramCounts[gram];
            sumOfSquareGramCounts += Math.pow(gramCount, 2);
            if (gram in this.matchDict) {
                for (i = 0; i < this.matchDict[gram].length; ++i) {
                    index = this.matchDict[gram][i][0];
                    otherGramCount = this.matchDict[gram][i][1];
                    if (index in matches) {
                        matches[index] += gramCount * otherGramCount;
                    } else {
                        matches[index] = gramCount * otherGramCount;
                    }
                }
            }
        }

        function isEmptyObject(obj) {
            for(var prop in obj) {
                if(obj.hasOwnProperty(prop))
                    return false;
            }
            return true;
        }

        if (isEmptyObject(matches)) {
            return null;
        }

        var vectorNormal = Math.sqrt(sumOfSquareGramCounts),
            results = [],
            matchScore;
        // build a results list of [score, str]
        for (var matchIndex in matches) {
            matchScore = matches[matchIndex];
            results.push([matchScore / (vectorNormal * items[matchIndex][0]), items[matchIndex][1]]);
        }
        var sortDescending = function(a, b) {
            if (a[0] < b[0]) {
                return 1;
            } else if (a[0] > b[0]) {
                return -1;
            } else {
                return 0;
            }
        };
        results.sort(sortDescending);
        if (this.useLevenshtein) {
            var newResults = [],
                endIndex = Math.min(50, results.length);
            // truncate somewhat arbitrarily to 50
            for (var i = 0; i < endIndex; ++i) {
                newResults.push([_distance(results[i][1], normalizedValue), results[i][1]]);
            }
            results = newResults;
            results.sort(sortDescending);
        }
        var newResults = [];
        results.forEach(function(scoreWordPair) {
            if (scoreWordPair[0] >= minMatchScore) {
                newResults.push([scoreWordPair[0], this.exactSet[scoreWordPair[1]]]);
            }
        }.bind(this))
        return newResults;
    };

    fuzzyset.add = function(value) {
        var normalizedValue = this._normalizeStr(value);
        if (normalizedValue in this.exactSet) {
            return false;
        }

        var i = this.gramSizeLower;
        for (i; i < this.gramSizeUpper + 1; ++i) {
            this._add(value, i);
        }
    };

    fuzzyset._add = function(value, gramSize) {
        var normalizedValue = this._normalizeStr(value),
            items = this.items[gramSize] || [],
            index = items.length;

        items.push(0);
        var gramCounts = _gramCounter(normalizedValue, gramSize),
            sumOfSquareGramCounts = 0,
            gram, gramCount;
        for (gram in gramCounts) {
            gramCount = gramCounts[gram];
            sumOfSquareGramCounts += Math.pow(gramCount, 2);
            if (gram in this.matchDict) {
                this.matchDict[gram].push([index, gramCount]);
            } else {
                this.matchDict[gram] = [[index, gramCount]];
            }
        }
        var vectorNormal = Math.sqrt(sumOfSquareGramCounts);
        items[index] = [vectorNormal, normalizedValue];
        this.items[gramSize] = items;
        this.exactSet[normalizedValue] = value;
    };

    fuzzyset._normalizeStr = function(str) {
        if (Object.prototype.toString.call(str) !== '[object String]') throw 'Must use a string as argument to FuzzySet functions';
        return str.toLowerCase();
    };

    // return length of items in set
    fuzzyset.length = function() {
        var count = 0,
            prop;
        for (prop in this.exactSet) {
            if (this.exactSet.hasOwnProperty(prop)) {
                count += 1;
            }
        }
        return count;
    };

    // return is set is empty
    fuzzyset.isEmpty = function() {
        for (var prop in this.exactSet) {
            if (this.exactSet.hasOwnProperty(prop)) {
                return false;
            }
        }
        return true;
    };

    // return list of values loaded into set
    fuzzyset.values = function() {
        var values = [],
            prop;
        for (prop in this.exactSet) {
            if (this.exactSet.hasOwnProperty(prop)) {
                values.push(this.exactSet[prop]);
            }
        }
        return values;
    };


    // initialization
    var i = fuzzyset.gramSizeLower;
    for (i; i < fuzzyset.gramSizeUpper + 1; ++i) {
        fuzzyset.items[i] = [];
    }
    // add all the items to the set
    for (i = 0; i < arr.length; ++i) {
        fuzzyset.add(arr[i]);
    }

    return fuzzyset;
};

var root = this;
// Export the fuzzyset object for **CommonJS**, with backwards-compatibility
// for the old `require()` API. If we're not in CommonJS, add `_` to the
// global object.
if (typeof module !== 'undefined' && module.exports) {
    module.exports = FuzzySet;
    if(root)
    {
        root.FuzzySet = FuzzySet;
    }
} else {
    root.FuzzySet = FuzzySet;
}

})();

},{}],3:[function(require,module,exports){
"use strict";

var _fuzzyset = _interopRequireDefault(require("../../../../node_modules/fuzzyset.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// Polyfill for IE9
if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}

function renderMap() {
  if (document.querySelector('.global-map__map') == null) {
    return;
  }

  var height = 630;
  var width = height * 2.177;
  var world;
  var countryData;
  var customCentroids;
  var ie = false;
  var svg = d3.select('.global-map__map .map-wrap').select('svg').attr('viewBox', '0 0 ' + width + ' ' + height);

  if (svg.node().clientHeight == 150) {
    // We are dealing with IE, so disable zoom.
    ie = true;
    svg.attr('width', width).attr('height', height);
    d3.select('.map-wrap').style('width', function (d) {
      return "".concat(width, "px");
    }).style('margin', '0 auto').style('position', 'relative');
    d3.select('.global-map__caption').text('Click a country to see the solutions offered in that country.');
    d3.select('.global-map__search').style('display', 'none');
  }

  var xAxis = d3.scaleLinear().domain([0, 1]).range([0, width]);
  var yAxis = d3.scaleLinear().domain([0, 1]).range([0, height]); // Gives the user something to drag if don't click on land.

  var backdrop = svg.append('rect').attr('x', 0).attr('y', 0).attr('width', width).attr('height', height).attr('fill', '#f5f5f5');
  var g = svg.append('g'); // An overlay to transform without messing up the viz proper

  var zoomRect = svg.append('rect').attr('x', 0).attr('y', 0).attr('width', width).attr('height', height) // .attr('fill', '#f5f5f5')
  .style('fill', 'none').style('pointer-events', function (d) {
    return ie ? 'none' : 'all';
  }); // potentialProjections = [d3.geoEckert3(), d3.geoGinzburg4(), d3.geoAugust(),
  // d3.geoOrthographic(), d3.geoAzimuthalEquidistant(), d3.geoEquirectangular(),
  // d3.geoNaturalEarth1()]

  var projection = d3.geoRobinson().scale(240).center([15, 10]).translate([width / 2, height / 2]);

  function zoomed() {
    emptySearchBox();
    var _d3$event$transform = d3.event.transform,
        k = _d3$event$transform.k,
        x = _d3$event$transform.x,
        y = _d3$event$transform.y;
    g.attr('transform', d3.event.transform);
    g.selectAll('path').attr('stroke-width', 1.2 / k);
    positionTooltip();
  }

  var zoom = d3.zoom().extent([[0, 0], [width, height]]).scaleExtent([1, 16]).translateExtent([[-(width * 0.1), -(height * 0.1)], [width * 1.1, height * 1.1]]);
  zoomRect.call(zoom.on('zoom', zoomed));
  var path = d3.geoPath().projection(projection);
  var recognizedRegions = ['Americas', 'Asia-Pacific', 'Europe', 'Africa and the Middle East'];
  var blue = '#00b5f0';
  var green = '#8bc348';
  var orange = '#f37521';
  var purple = '#7b0c72';
  var palette = [blue, purple, green, orange];
  var colors = d3.scaleOrdinal().domain(recognizedRegions).range(palette);
  var tooltip = d3.select('.global-map-tooltip-js');
  var tooltipCountryName = tooltip.select('.global-map-tooltip-country-name-js');
  var placard = tooltip.select('.tooltip-placard-js'); // START DROP SHADOW
  // filters go in defs element

  var defs = svg.append('defs');
  var newDrop = defs.append('filter').attr('id', 'drop-shadow').attr('height', '400%').attr('width', '400%');
  newDrop.append('feDropShadow').attr('dx', 5).attr('dy', 5).attr('stdDeviation', 5); // create filter with id #drop-shadow
  // height=130% so that the shadow is not clipped

  var filter = defs.append('filter').attr('id', 'drop-shadow--original').attr('height', '200%').attr('width', '200%'); // SourceAlpha refers to opacity of graphic that this filter will be applied to
  // convolve that with a Gaussian with standard deviation 3 and store result
  // in blur

  filter.append('feGaussianBlur').attr('in', 'SourceAlpha').attr('stdDeviation', 5).attr('result', 'blur'); // translate output of Gaussian blur to the right and downwards with 2px
  // store result in offsetBlur

  filter.append('feOffset').attr('in', 'blur').attr('dx', 5).attr('dy', 5).attr('result', 'offsetBlur'); // overlay original SourceGraphic over translated blurred opacity by using
  // feMerge filter. Order of specifying inputs is important!

  var feMerge = filter.append('feMerge');
  feMerge.append('feMergeNode').attr('in', 'offsetBlur');
  feMerge.append('feMergeNode').attr('in', 'SourceGraphic'); // END DROP SHADOW

  d3.json('/assets/data/sedgwick-world.json').then(function (world) {
    var countryFeatures = topojson.feature(world, world.objects.countries).features; // // Equip countries with their custom centroids
    // countryFeatures.map((x) => {
    //   let customCentroid = customCentroids.find(y => y.id === x.id);
    //   if (customCentroid !== undefined) {
    //     x.properties.centroid = {
    //       lat: +customCentroid.lat,
    //       long: +customCentroid.long,
    //     };
    //     return x;
    //   } else {
    //     x.properties.centroid = {
    //       lat: 0,
    //       long: 0,
    //     };
    //   }
    // });
    // let countries = g.append("path")
    //     // .data(countryFeatures)
    //     .datum(countryFeatureCollection)
    //       .attr('d', path)
    //       .attr('fill', '#d8d8d8')
    //       .attr('stroke', 'white')

    var countries = g.selectAll('.map__country').data(countryFeatures).enter().append('path').attr('class', 'map__country').attr('d', path).attr('data-name', function (d) {
      return d.properties.NAME_LONG;
    }).attr('fill', function (d) {
      var attributes = d.properties;
      var matchedEntry = entries.filter(function (x) {
        return attributes.ISO_A2.toLowerCase() === x.code;
      });

      if (recognizedRegions.includes(attributes.REGION_UN) && matchedEntry.length > 0) {
        d3.select(this).classed('country--active', true);
        return colors(attributes.REGION_UN);
      } else {
        return '#d8d8d8';
      }
    }) // .attr('fill', function(d) {
    //   let attributes = countryData.find(x => d.id === x.ISO_N3.padStart(3, 0));
    //   if (attributes !== undefined) {
    //     let matchedEntry = entries.filter(x => attributes.ISO_A2.toLowerCase() === x.code);
    //     if (recognizedRegions.includes(attributes.REGION_UN) && matchedEntry.length > 0) {
    //       d3.select(this).classed('country--active', true)
    //       return colors(attributes.REGION_UN)
    //     } else {
    //       return '#d8d8d8';
    //     }
    //   } else {
    //     return '#d8d8d8';
    //   }
    // })
    .attr('stroke', 'white').attr('data-id', function (d) {
      return d.id;
    });
    var missingNations = [{
      properties: {
        'NAME_LONG': 'Faroe Islands',
        'REGION_UN': 'Europe',
        'ISO_A2': 'FO',
        id: '234',
        LAT: 62.163594,
        LONG: -7.002323
      }
    }, {
      properties: {
        'NAME_LONG': 'Dutch Caribbean',
        'REGION_UN': 'Americas',
        'ISO_A2': 'AN',
        LAT: 13.306,
        LONG: -68.731
      }
    }];
    var missingDots = g.selectAll('.missing-nations').data(missingNations).enter().append('circle');
    missingDots.attr('class', 'country--active map__country');
    missingDots.attr('cx', function (d) {
      var centroid = projection([d.properties.LONG, d.properties.LAT]);
      return centroid[0];
    }).attr('cy', function (d) {
      var centroid = projection([d.properties.LONG, d.properties.LAT]);
      return centroid[1];
    }).attr('r', 5).attr('fill', function (d) {
      return colors(d.properties.REGION_UN);
    }); // const centroids = countryFeatures.map(function(x) {
    //   let name = countryIndex.find(y => y.key == x.id);
    //   if (name == undefined) {
    //     // console.info(x)
    //   } else {
    //     name = name.values[0]['NAME_LONG'] 
    //   }
    //   let attrs = { id: x.id, name: name, centroid: path.centroid(x)}
    //   return attrs
    // });
    // SEE WHICH COUNTRIES ARE NOT REPRESENTED IN THE GEOMETRY DATA
    // console.info(countryData.filter(x => countryFeatures.map(y => y.id).indexOf(x["ISO_N3"].padStart(3,0)) == -1))
    // g.selectAll(".country-labels").data(centroids).enter().append("text")
    //     .attr('x', d => d.centroid[0])
    //     .attr('y', d => d.centroid[1])
    //     .attr("text-anchor", "middle")
    //     .text(d => d.name)
    // // START EDITING CENTROIDS
    // let dots = g.selectAll('.centroids').data(centroids)
    //   .enter().append('circle')
    //     .attr('cx', d => d.centroid[0])
    //     .attr('cy', d => d.centroid[1])
    //     .attr('fill', 'magenta')
    //     .attr('r', 5)
    //     .attr('data-id', d => d.id)
    // let drag_handler = d3.drag()
    //                 .on('start', drag_start)
    //                 .on('drag', drag_drag)
    // function drag_start() {
    //             start_x = +d3.event.x
    //             start_y = +d3.event.y
    //         }
    // function drag_drag(d) {
    //             d3.select(this)
    //               .attr('cx', d.x = d3.event.x).attr('cy', d.y = d3.event.y)
    //         }
    // drag_handler(dots)
    // dots.on('click', function() {
    //   let centroid = d3.select(this);
    //   let x = (centroid[0] / width) * 100;
    //   let y = (centroid[1] / height) * 100;
    //   centroid
    //       .attr("cx", x)
    //       .attr("cy", y)
    // })
    // // END EDITING CENTROIDS

    var countryDict = (0, _fuzzyset.default)([], false);
    countries.filter(function (d) {
      return d3.select(this).classed("country--active");
    }).each(function (x) {
      return countryDict.add(x.properties.NAME_LONG);
    });
    countries.on('click', function () {
      var country = d3.select(this);

      if (country.classed('country--active') === false) {
        resetCountries();
        return;
      }

      resetCountries(); // Deal with currently active

      country.classed('tooltip--active', true);
      country.raise();
      missingDots.raise();
      country.transition().attr('transform', 'translate(0,-5)'); // country.style('filter', 'url(#drop-shadow)');

      positionTooltip();
      emptySearchBox();
    });
    d3.select('.js-country-search').on('keydown', function () {
      if (d3.event.key === 'Enter') {
        var topResult = d3.select('.global-map-search__result-box').select('.global-map-search__result');

        if (topResult.nodes().length > 0) {
          zoomToCountry(topResult.datum());
        }

        emptySearchBox();
      }
    });
    d3.select('.js-country-search').on('input', function () {
      var nearest = countryDict.get(this.value);
      var results = d3.select('.global-map-search__result-box').selectAll('.global-map-search__result');

      if (nearest === null) {
        emptySearchBox();
        return;
      }

      ;
      d3.select(this).classed('global-map__searchbox--open', true);
      results = results.data(nearest, function (d) {
        return d[1];
      });
      results.exit().remove();
      results.enter().append('div').classed('global-map-search__result', true).text(function (d) {
        return d[1];
      }).merge(results).order().on('click', zoomToCountry);
    });
    zoomRect.raise();

    function zoomToCountry(countryMatch) {
      emptySearchBox();
      var bounds;
      d3.selectAll('.map__country').classed('tooltip--active', false);
      var country = countries.filter(function (x) {
        return x.properties.NAME_LONG == countryMatch[1];
      }).classed('tooltip--active', true);
      var d = country.data()[0];

      if (d.properties.BOUNDING_BOX) {
        bounds = d.properties.BOUNDING_BOX.map(projection);
      } else {
        bounds = path.bounds(d);
      }

      var dx = bounds[1][0] - bounds[0][0],
          dy = bounds[1][1] - bounds[0][1],
          x = (bounds[0][0] + bounds[1][0]) / 2,
          y = (bounds[0][1] + bounds[1][1]) / 2;
      var k = .75 / Math.max(dx / width, dy / height);
      k = k > 16 ? 16 : k;
      var translate = [width / 2 - k * x, height / 2 - k * y];
      zoom.transform(zoomRect.transition().duration(2000).ease(d3.easeQuadInOut), d3.zoomIdentity.translate(translate[0], translate[1]).scale(k));
      positionTooltip();
    }

    d3.select('.zoom-controls').raise();
    d3.selectAll('.js-zoom').on('click', function () {
      function translate(transform, p0, p1) {
        var x = p0[0] - p1[0] * transform.k;
        var y = p0[1] - p1[1] * transform.k;
        return x === transform.x && y === transform.y ? transform : d3.zoomIdentity.translate(x, y).scale(transform.k);
      }

      var _zoom$scaleExtent = zoom.scaleExtent(),
          _zoom$scaleExtent2 = _slicedToArray(_zoom$scaleExtent, 2),
          minZoom = _zoom$scaleExtent2[0],
          maxZoom = _zoom$scaleExtent2[1];

      var zoomDir = d3.select(this).classed('js-zoom--out') ? 'out' : 'in';
      var t = d3.zoomTransform(zoomRect.node());
      if (zoomDir === 'in' && t.k >= maxZoom) return;
      if (zoomDir === 'out' && t.k <= minZoom) return;
      var scaleFactor = zoomDir === 'out' ? 0.5 : 2;
      var nextZoom = t.k * scaleFactor;

      if (nextZoom <= minZoom) {
        scaleFactor = 1 / t.k;
      }

      if (nextZoom >= maxZoom) {
        scaleFactor = maxZoom / nextZoom;
      }

      var zoomedT = t.scale(scaleFactor);
      var p = [width / 2, height / 2];
      var invertedP = t.invert(p);
      var newTransform = translate(zoomedT, p, invertedP);
      zoom.transform(zoomRect, newTransform);
    });
    zoomRect.on('click', function () {
      zoomRect.style('pointer-events', 'none');
      var country = d3.select(document.elementFromPoint(d3.event.x, d3.event.y));
      zoomRect.style('pointer-events', 'all');

      if (country.classed('country--active') === false) {
        resetCountries();
        return;
      }

      resetCountries(); // Deal with currently active

      country.classed('tooltip--active', true);
      country.raise();
      missingDots.raise();
      country.transition().attr('transform', 'translate(0,-5)'); // country.style('filter', 'url(#drop-shadow)');

      positionTooltip();
      emptySearchBox();
    });
    tooltip.on('click', function (d) {
      var entry = entries.find(function (x) {
        return d.ISO_A2.toLowerCase() === x.code;
      });
      document.location.href = entry.url;
    });
    backdrop.on('click', function () {
      // console.info()
      tooltip.style('display', 'none');
      resetCountries();
    });

    function toggleTooltip() {
      tooltip.style('display') == 'none' ? tooltip.style('display', 'block') : tooltip.style('display', 'none');
    }

    function resetCountries() {
      tooltip.style('display', 'none'); // Zero out last active

      var countries = d3.selectAll('.map__country');
      countries.classed('tooltip--active', false);
      countries.transition().attr('transform', 'translate(0,0)');
      countries.style('filter', null);
    }
  }); // end of promise

  function translate(transform, p0, p1) {
    var x = p0[0] - p1[0] * transform.k;
    var y = p0[1] - p1[1] * transform.k;
    return x === transform.x && y === transform.y ? transform : d3.zoomIdentity.translate(x, y).scale(transform.k);
  }

  function emptySearchBox() {
    var searchBox = d3.select('.js-country-search');
    d3.select('.global-map-search__result-box').selectAll('.global-map-search__result').data([]).exit().remove();
    searchBox.classed('global-map__searchbox--open', false).attr('value', '');
  }

  function positionTooltip() {
    var country = d3.select('.tooltip--active');
    if (country.nodes().length == 0) return;
    var attributes = country.datum().properties;
    tooltipCountryName.text(function (d) {
      return attributes.NAME_LONG;
    });
    tooltip.datum(attributes);
    var t = d3.zoomTransform(zoomRect.node());
    xAxis.range([0 - t.x, width - t.x]);
    yAxis.range([0 - t.y, height - t.y]); // TODO: Why not pop up the tooltip wherever they happened to click?
    // We know which country it is based on the click event. Currently,
    // if you zoom into French Suriname and click, the tooltip will pop
    // up back on the Continent.

    var lat = country.datum().properties.LAT;
    var long = country.datum().properties.LONG;
    var centroid = projection([long, lat]).map(function (x) {
      return x * t.k;
    });
    var centroidPct = [xAxis.invert(centroid[0]) * 100, yAxis.invert(centroid[1]) * 100];
    var x = centroidPct[0];
    var y = centroidPct[1];
    tooltip.style('display', 'block');
    tooltip.style('left', "".concat(x, "%")).style('right', 'auto').style('bottom', "".concat(100 - y, "%")).style('top', 'auto');
    placard.classed('top', false).classed('right', false);
    var placardDims = {
      width: placard.node().offsetWidth,
      height: placard.node().offsetHeight
    };
    var svgDims = {
      width: svg.node().clientWidth,
      height: svg.node().clientHeight
    };
    var safeY = placardDims.height * 1.05;
    var safeX = svgDims.width - (placardDims.width + svgDims.width * 0.05); // top and right side have buffers that equal to width of tooltip / height of tooltip + 50px change.
    // Check offset of centroid to see if we're within that

    if (svgDims.width * (x / 100) > safeX) {
      tooltip.style('right', "".concat(100 - x, "%"));
      tooltip.style('left', 'auto');
      placard.classed('right', true);
    }

    if (svgDims.height * (y / 100) < safeY) {
      placard.classed('top', true);
      tooltip.style('top', "".concat(y, "%"));
      tooltip.style('bottom', 'auto');
    }
  }
}

renderMap();

},{"../../../../node_modules/fuzzyset.js":1}]},{},[3])

